import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Bandaid = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="bandaid icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M1.82843 8.81049C0.266336 7.24839 0.266336 4.71573 1.82843 3.15364L3.17158 1.81049C4.73368 0.248391 7.26634 0.248392 8.82843 1.81049L11 3.98206L4.00001 10.9821L1.82843 8.81049Z"
    />
    <path
      className={pathClass}
      d="M13 19.9821L20 12.9821L22.1716 15.1536C23.7337 16.7157 23.7337 19.2484 22.1716 20.8105L20.8284 22.1536C19.2663 23.7157 16.7337 23.7157 15.1716 22.1536L13 19.9821Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.82843 15.1536C0.266337 16.7157 0.266335 19.2484 1.82843 20.8105L3.17158 22.1536C4.73368 23.7157 7.26634 23.7157 8.82843 22.1536L22.1716 8.81049C23.7337 7.24839 23.7337 4.71573 22.1716 3.15364L20.8284 1.81049C19.2663 0.248392 16.7337 0.248392 15.1716 1.81049L1.82843 15.1536ZM12 9.98206C12.5523 9.98206 13 9.53435 13 8.98206C13 8.42978 12.5523 7.98206 12 7.98206C11.4477 7.98206 11 8.42978 11 8.98206C11 9.53435 11.4477 9.98206 12 9.98206ZM10 11.9821C10 12.5343 9.55229 12.9821 9.00001 12.9821C8.44772 12.9821 8.00001 12.5343 8.00001 11.9821C8.00001 11.4298 8.44772 10.9821 9.00001 10.9821C9.55229 10.9821 10 11.4298 10 11.9821ZM15 12.9821C15.5523 12.9821 16 12.5343 16 11.9821C16 11.4298 15.5523 10.9821 15 10.9821C14.4477 10.9821 14 11.4298 14 11.9821C14 12.5343 14.4477 12.9821 15 12.9821ZM13 14.9821C13 15.5343 12.5523 15.9821 12 15.9821C11.4477 15.9821 11 15.5343 11 14.9821C11 14.4298 11.4477 13.9821 12 13.9821C12.5523 13.9821 13 14.4298 13 14.9821Z"
    />
  </svg>
)
